const automationTaskTypes = [
	'initial-coordinator-allocation',
	'coordinator-allocation',
	'final-situation-coordinator-allocation',
	'administrative-manager-allocation',
]
const allocationTaskTypes = [
	'triage-opinion',
	'management-opinion',
	'relapse-opinion',
	'clinical-followup-opinion',
	'causal-link-opinion',
	'transfer-opinion',
	'medical-acts-clinical-approval',
	'appointment-clinical-approval',
	'surgery-clinical-approval',
	'relapse-clinical-approval',
	'transfer-clinical-approval',
	'final-situation-prevision',
	'non-surgical-admission-requisition',
	'process-forwarding',
	'cancel-request-appointment',
	'cancel-request-requisition',
]
const priorityTaskTypes = [
	'triage-opinion',
	'triage-opinion-followup',
	'management-opinion',
	'relapse-opinion',
	'clinical-followup-opinion',
	'causal-link-opinion',
	'transfer-opinion',
	'medical-acts-clinical-approval',
	'appointment-clinical-approval',
	'surgery-clinical-approval',
	'relapse-clinical-approval',
	'transfer-clinical-approval',
	'final-situation-prevision',
	'non-surgical-admission-requisition',
	'process-forwarding',
]
const eventsSubscriptionsTypes = ['system-notifications']

export const rulesPaths = [
	`/settings-v2/:ruleType(automation)/:taskType(${automationTaskTypes.join(
		'|'
	)})`,
	`/settings-v2/:ruleType(allocation)/:taskType(${allocationTaskTypes.join(
		'|'
	)})`,
	`/settings-v2/:ruleType(priority)/:taskType(${priorityTaskTypes.join(
		'|'
	)})`,
]

export const eventsSubscriptionsPaths = [
	`/settings-v2/:ruleType(events-subscriptions)/:taskType(${eventsSubscriptionsTypes.join(
		'|'
	)})`,
]

export const rulesNavigation = (i18n) => {
	return {
		automation: [
			{
				name: i18n`Initial coordinator allocation`,
				to: '/settings-v2/automation/initial-coordinator-allocation/',
				icon: 'coordinator-allocation',
				exact: true,
			},
			{
				name: i18n`Coordinator allocation`,
				to: '/settings-v2/automation/coordinator-allocation/',
				icon: 'coordinator-allocation',
				exact: true,
			},
			{
				name: i18n`Final situation coordinator allocation`,
				to: '/settings-v2/automation/final-situation-coordinator-allocation/',
				icon: 'coordinator-allocation',
				exact: true,
			},
			{
				name: i18n`Administrative manager allocation`,
				to: '/settings-v2/automation/administrative-manager-allocation/',
				icon: 'coordinator-allocation',
				exact: true,
			},
		],
		allocation: [
			{
				name: i18n`Transfer opinion`,
				to: '/settings-v2/allocation/transfer-opinion/',
				exact: true,
			},
			{
				name: i18n`Causal link opinion`,
				to: '/settings-v2/allocation/causal-link-opinion/',
				exact: true,
			},
			{
				name: i18n`Clinical followup opinion`,
				to: '/settings-v2/allocation/clinical-followup-opinion/',
				exact: true,
			},
			{
				name: i18n`Relapse opinion`,
				to: '/settings-v2/allocation/relapse-opinion/',
				exact: true,
			},
			{
				name: i18n`Triage opinion`,
				to: '/settings-v2/allocation/triage-opinion/',
				exact: true,
			},
			{
				name: i18n`Management opinion`,
				to: '/settings-v2/allocation/management-opinion/',
				exact: true,
			},
			{
				name: i18n`Medical acts clinical evaluation`,
				to: '/settings-v2/allocation/medical-acts-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Appointment clinical approval`,
				to: '/settings-v2/allocation/appointment-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Surgery clinical approval`,
				to: '/settings-v2/allocation/surgery-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Relapse clinical approval`,
				to: '/settings-v2/allocation/relapse-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Transfer clinical approval`,
				to: '/settings-v2/allocation/transfer-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Final situation prevision`,
				to: '/settings-v2/allocation/final-situation-prevision/',
				exact: true,
			},
			{
				name: i18n`Non Surgical Admission`,
				to: '/settings-v2/allocation/non-surgical-admission-requisition/',
				exact: true,
			},
			{
				name: i18n`Process forwarding`,
				to: '/settings-v2/allocation/process-forwarding/',
				exact: true,
			},
			{
				name: i18n`CancelRequestAppointment`,
				to: '/settings-v2/allocation/cancel-request-appointment/',
				exact: true,
			},
			{
				name: i18n`CancelRequestRequisition`,
				to: '/settings-v2/allocation/cancel-request-requisition/',
				exact: true,
			},
		],
		priority: [
			{
				name: i18n`Transfer opinion`,
				to: '/settings-v2/priority/transfer-opinion/',
				exact: true,
			},
			{
				name: i18n`Causal link opinion`,
				to: '/settings-v2/priority/causal-link-opinion/',
				exact: true,
			},
			{
				name: i18n`Clinical followup opinion`,
				to: '/settings-v2/priority/clinical-followup-opinion/',
				exact: true,
			},
			{
				name: i18n`Relapse opinion`,
				to: '/settings-v2/priority/relapse-opinion/',
				exact: true,
			},
			{
				name: i18n`Triage opinion`,
				to: '/settings-v2/priority/triage-opinion/',
				exact: true,
			},
			{
				name: i18n`Triage opinion - Follow up`,
				to: '/settings-v2/priority/triage-opinion-followup/',
				exact: true,
			},
			{
				name: i18n`Management opinion`,
				to: '/settings-v2/priority/management-opinion/',
				exact: true,
			},
			{
				name: i18n`Medical acts clinical evaluation`,
				to: '/settings-v2/priority/medical-acts-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Appointment clinical approval`,
				to: '/settings-v2/priority/appointment-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Surgery clinical approval`,
				to: '/settings-v2/priority/surgery-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Relapse clinical approval`,
				to: '/settings-v2/priority/relapse-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Transfer clinical approval`,
				to: '/settings-v2/priority/transfer-clinical-approval/',
				exact: true,
			},
			{
				name: i18n`Final situation prevision`,
				to: '/settings-v2/priority/final-situation-prevision/',
				exact: true,
			},
			{
				name: i18n`Non Surgical Admission`,
				to: '/settings-v2/priority/non-surgical-admission-requisition/',
				exact: true,
			},
			{
				name: i18n`Process forwarding`,
				to: '/settings-v2/priority/process-forwarding/',
				exact: true,
			},
		],
		eventsSubscriptions: [
			{
				name: i18n`System notifications`,
				to: '/settings-v2/events-subscriptions/system-notifications/',
				exact: true,
			},
		],
	}
}

const navigation = (i18n, isAdmin, isManager, limit) => {
	return [
		{
			name: i18n`Home`,
			to: '/',
			icon: 'home',
			exact: true,
		},
		// {
		// 	name: i18n`Tasks`,
		// 	to: '/tasks/',
		// 	icon: 'tasks',
		// },
		{
			name: i18n`Inbox`,
			id: 'inbox',
			icon: 'messages',
		},
		{
			name: i18n`Clinical Processes`,
			to: '/clinical-processes/',
			icon: 'reports',
		},
		{
			name: i18n`Notifications`,
			to: '/notifications/',
			icon: 'messages',
		},
		{
			name: i18n`Users`,
			to: '/users/',
			icon: 'users',
		},
		isAdmin || isManager
			? {
					name: i18n`Tasks`,
					to: '/tasks/',
					icon: 'tasks',
			  }
			: null,
		{
			name: i18n`Personal area`,
			to: '/personal-area',
			icon: 'note-v2',
			exact: true,
		},
		isAdmin
			? {
					name: i18n`Protocols`,
					to: '/protocols',
					icon: 'note-v2',
					exact: true,
			  }
			: null,
		isAdmin
			? {
					name: i18n`Settings`,
					to: '/settings-v2/',
					icon: 'settings',
			  }
			: null,
	]
		.filter((entry) => entry)
		.slice(0, limit)
}

export default navigation
